/**
 * It takes a filename as a string and returns the file extension as a string
 * @param filename - The filename to get the extension from.
 * @returns The file extension of the file name.
 */
 export default function getFileExtension(filename)  {
    return filename.match(/\.([^\.]+)$/)[1] || '';
}